import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

let _token = null;
export function setToken(token) { _token = token; }

export async function deleteCtes(accessKeys) {
  const url = new URL("/cte", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...(_token ? { Authorization: `Bearer ${_token}` } : {}),
    },
    body: JSON.stringify({ accesskeys: accessKeys }),
  });

  const text = await response.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao apagar CT-e"));
  }

  return data;
}
